<template>
  <div style="">
    <el-card shadow="never" style="padding-bottom: 15px">
      <el-col :xs="12" :sm="12" :md="12" :lg="4" style="padding-top: 5pt">
        <span class="head-title">Manage Payroll Report ( {{ aStatusLabel }} )</span>
      </el-col>
    </el-card>
    <el-row :gutter="2">
      <el-col :xs="12" :sm="12" :md="12" :lg="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>List of Posted Ledger</span>
          </div>
          <!--el-radio-group v-model="astatus" @change="getAll">
            <el-radio-button v-for="status in appointStatus" :key="status.id" :value="status.id" :label="status.id">{{ status.label }}</el-radio-button>
          </el-radio-group-->
          <el-table
            v-loading="loading"
            :data="report"
            size="small"
            style="width: 100%">
            <el-table-column
              prop="year"
              label="Year"/>
            <el-table-column
              label="Month">
              <template slot-scope="scope">
                {{ monthList[scope.row.month - 1] }}
              </template>
            </el-table-column>
            <el-table-column
              label="Generate">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="open(scope.row)"><i class="fas fa-money-bill" /> Generate</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
          </div>
          <el-alert
            :closable="false"
            title="Info"
            type="info"
            description="This panel generates payroll report."
            show-icon />
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="18">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span v-show="!progress">List of Report</span>
            <span v-show="progress"><el-progress :text-inside="true" :stroke-width="24" :percentage="percent" :format="format"/></span>
          </div>
          <div >
            <payroll-report :key="keys" :month-list="monthList" :status="astatus"/>
          </div>
          <el-alert
            :closable="false"
            title="Info"
            type="info"
            description="This are the list of generated ledger"
            show-icon />
        </el-card>
      </el-col>
    </el-row>
    <!--el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      title="Select Status to proceed"
      width="30%">
      <div>
        <div>
          <el-radio-group v-model="astatus" required>
            <el-radio v-for="status in appointStatus" :key="status.id" :value="status.id" :label="status.id" border>{{ status.label }}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="primary" @click="open(dataByRow)">Confirm</el-button>
      </span>
    </el-dialog-->
  </div>
</template>

<script>
import PayrollReport from './payroll_report'
import { Report } from '@/api/payroll/report'
import { SummaryLedger } from '@/api/payroll/summaryledger'
import { NotifySuccess, NotifyWarning } from '../../../helper/Helper'
export default {
  name: 'Report',
  components: {
    PayrollReport
  },
  data() {
    return {
      astatus: parseInt(this.$store.getters.APStatus),
      appointStatus: [
        { label: 'Permanent', id: 3 },
        { label: 'Contractual', id: 2 },
        { label: 'Casual', id: 1 }
      ],
      // dataByRow: null,
      // dialogVisible: false,
      meta: {
        page: 1
      },
      form: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      quencina: '',
      url: '',
      base_url: this.$store.getters.base_url,
      report: [],
      loading: false,
      progress: false,
      percent: 0,
      keys: 0,
      startYear: 2017,
      currentYear: '',
      monthList: [
        'JANUARY',
        'FEBRUARY',
        'MARCH',
        'APRIL',
        'MAY',
        'JUNE',
        'JULY',
        'AUGUST',
        'SEPTEMBER',
        'OCTOBER',
        'NOVEMBER',
        'DECEMBER'
      ],
      aStatusLabel: null,
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch('APStatus', this.$store.getters.APStatus)
    if (this.astatus === 3) { this.aStatusLabel = 'Permanent' }
    if (this.astatus === 2) { this.aStatusLabel = 'Contractual' }
    if (this.astatus === 1) { this.aStatusLabel = 'Casual' }
    this.getCurrentYear()
    this.getAll()
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    // showDialog(row) {
    //   this.dialogVisible = true
    //   this.dataByRow = row
    // },
    getAll() {
      this.loading = true
      SummaryLedger({ page: this.meta.page, tenure: this.astatus, campus_id: this.campus_id }, 'get', '').then(res => {
        this.report = res.data.summary_ledger
        this.meta = res.data.meta
        this.loading = false
        this.keys++
      }).catch(error => {
        console.log(error)
      })
    },
    open(row) {
      this.$confirm('Please make sure that you`ve already review the personnel deductions. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.form = {
          year: row.year,
          month: row.month,
          astatus_id: row.flag
        }
        this.generatePayroll()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Generate Payroll Cancel'
        })
      })
    },
    generatePayroll() {
      this.form.campus_id = this.campus_id
      Report(this.form, 'get', '').then(res => {
        if (res.data.message === 'Already Posted') {
          NotifyWarning('Already Generated!')
        } else if (res.data.message === 'Success') {
          NotifySuccess('Successfully Generated!')
          this.keys++
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getCurrentYear() {
      this.currentYear = new Date().getFullYear()
    },
    format(percentage) {
      return percentage === 100 ? 'Full' : `${percentage}%`
    }
  }
}
</script>

<style lang="scss">
  .el-alert--info {
    background-color: #e1ffd0 !important;
  }
</style>
